let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jvpT9")).then(() => parcelRequire('3wdqM'));